import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import ReCAPTCHA from "react-google-recaptcha";
import Footer from "./Footer";


let config = require('../Config/appConfig.json');
let api_credentials_url = config.GET_API_CREDENTIALS;
let URL_SEND_EMAIL = config.SEND_MAIL_URL;
let KEY_SENDING_MAIL = config.KEY_SENDING_MAIL;
const context = "Description.js";
const NOTIFICATION_TYPE_ERROR = "error";
const NOTIFICATION_TYPE_SUCCESS = "success";
let self = null;
@inject("appStore")
@observer
class Description extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCaptchaverified: false,
            name: "",
            email: "",
            subject: "",
            phone: "",
            message: ""
        };
    }

    componentWillMount = () => {
        self = this;
    }

    onNameChange = (event) => {
        this.setState({
            name: event.target.value
        })
    }

    onEmailChange = (event) => {
        this.setState({
            email: event.target.value
        })
    }

    onSubjectChange = (event) => {
        this.setState({
            subject: event.target.value
        })
    }

    onPhoneChange = (event) => {
        this.setState({
            phone: event.target.value
        })
    }

    onMessageChange = (event) => {
        this.setState({
            message: event.target.value
        })
    }

    onReCaptchaChange = (value) => {
        //console.log("ReCaptcha Value => ", value)
        if (value.length > 0) {
            //console.log("Verified")
            this.setState({
                isCaptchaverified: true
            })
        }
    }

    submitForm = () => {
        console.log("Submit Called");
        var isCaptchaverified = this.state.isCaptchaverified;
        var name = this.state.name;
        var email = this.state.email;
        var subject = this.state.subject;
        var phone = this.state.phone;
        var message = this.state.message;
        if (isCaptchaverified) {
            console.log("Name  => " + name);
            console.log("email  => " + email);
            console.log("subject  => " + subject);
            console.log("phone  => " + phone);
            console.log("message  => " + message);

            if (name == null || name == "" || name == undefined || name.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Name field is invalid");
            } else if (email == null || email == "" || email == undefined || email.length < 6 || email == "email@client.com" || /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Email field is invalid");
            } else if (subject == null || subject == "" || subject == undefined || subject.length < 3) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Subject field is invalid");
            } else if (phone == null || phone == "" || phone == undefined || phone.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Phone field is invalid");
            } else if (message == null || message == "" || message == undefined || message.length < 10) {
                this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Message field is invalid");
            } else {
                var txt = "Name : ".concat(name);
                txt = txt.concat("\nEmail Id : ", email);
                txt = txt.concat("\nMobile : ", phone);
                txt = txt.concat("\nSubject : ", subject);
                txt = txt.concat("\nMessage: ", message);
                this.sendMail(txt, subject)
            }

        } else {
            this.addNotifiation(NOTIFICATION_TYPE_ERROR, "Please verify the captcha")
        }
    }

    addNotifiation = (type, message) => {
        window.sendNotification(type, message)
    }

    sendMail = (text, subject) => {
        var info = {
            secret_key: KEY_SENDING_MAIL,
            subject: subject,
            text: text
        };
        fetch(URL_SEND_EMAIL, {
            method: 'POST',
            //headers: JSON.stringify(headers),
            body: JSON.stringify(info)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {
                    var resJson = JSON.stringify(responseJson);
                    console.log("Success => " + resJson)
                    self.addNotifiation(NOTIFICATION_TYPE_SUCCESS, "Message sent successfully");
                } catch (e) {
                    console.log("1 Error => " + e)
                }
            })
            .catch(function (error) {
                console.log("2 Error => " + error)
            });
    }

    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }
    render() {

        return (
            <div>
                <section className="pt-120 pb-70 section-pattern" data-bg-img="assets/img/section-pattern/work-process-pattern.png">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="section-title text-center">
                                    <h3>Thinking about a trip with your friends?</h3>
                                    <h2>No road is too long...</h2>

                                </div>
                            </div>
                        </div>
                        <div className="row process-bg" style={{ 'backgroundImage': 'url("assets/img/process_shape.png")' }}>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/custom_icons/Process/process-fill-form.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Fill up your trip details</h3>
                                        <p>For your best comfort route with closest pickup and drop locations and desired time.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/custom_icons/Process/process-customer-support.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Contact</h3>
                                        <p>You're ready for the weekend getaways.Contact us through this website and we will get back to you.</p>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/custom_icons/Process/process-payment.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Payment</h3>
                                        <p>Make payment only after everything is confirmed.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6 single-process-wrapper">
                                <div className="single-process text-center">
                                    <div className="image"> <img src="assets/custom_icons/Process/process-complete-journey.png" data-rjs="2" alt="" /> </div>
                                    <div className="content">
                                        <h3>Set for the trip</h3>
                                        <p>That's it, You are set to go!</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        );
    }
}

export default withRouter(Description);


// WEBPACK FOOTER //
// ./src/Pages/Description.js